module.exports = __webpack_public_path__ + "img/p1-desc@2x.ce272766.jpg";